import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { createSelector } from './selectorWrapper'
import { simpleSelectors, pageSelectors } from './basicState'
import { TitleIdToAction, ActionFragment } from '../reducers/action'
import { PurchaseDetails } from '../reducers/purchase'
import {
  getTvodWinnersChildren,
  getMoreWaysToWatchChildren,
} from './acquisitionActions'
import { isTvodAction } from '../utils/getAcquisitionActionChildren'
import { btfActions } from './actionFragment'
import { TitleIdToSelf } from '../reducers/self'

export interface IPurchaseDetails {
  canonicalId: string
  offer: WpsRuntime.atv.wps.PurchaseActionProps
  gti: string | undefined
}

export type OfferTokenToPurchaseAction = {
  [offerToken: string]: IPurchaseDetails | undefined
}

const getMoreWaysToWatchOffers = (
  acquisitionActions?: WpsRuntime.atv.wps.AcquisitionActionsModel
) =>
  getMoreWaysToWatchChildren(
    acquisitionActions && acquisitionActions.moreWaysToWatch
  ).filter(isTvodAction)

const getTvodWinnersOfferAsins = (
  acquisitionActions?: WpsRuntime.atv.wps.AcquisitionActionsModel
) =>
  getTvodWinnersChildren(
    acquisitionActions && acquisitionActions.tvodWinners
  ).filter(isTvodAction)

export const offerTokenToPurchaseActionSelector = createSelector(
  [
    simpleSelectors.pageTitleId,
    pageSelectors.actionAtf,
    simpleSelectors.self,
    btfActions,
  ],
  (
    pageTitleId,
    atfAction: ActionFragment,
    selfFragments: TitleIdToSelf,
    btfActions: TitleIdToAction
  ) => {
    const result: OfferTokenToPurchaseAction = {}
    const extractOffers = (actions: TitleIdToAction) => {
      Object.entries(actions).forEach(([canonicalId, action]) => {
        if (!action) {
          return
        }
        const self = selfFragments[canonicalId]
        const gti = self ? self.gti : undefined
        const { acquisitionActions } = action
        const offers = [
          ...getTvodWinnersOfferAsins(acquisitionActions),
          ...getMoreWaysToWatchOffers(acquisitionActions),
        ]
        offers.forEach(offer => {
          result[offer.offerToken] = {
            canonicalId,
            offer,
            gti,
          }
        })
      })
    }

    // Note: The BTF canonicalID for an episode will override the ATF canonical ID
    // for that same episode for TV Seasons
    extractOffers({ [pageTitleId]: atfAction })
    extractOffers(btfActions)
    return result
  }
)

export type PurchaseOffer = ReturnType<typeof purchaseSelector>

export const purchaseSelector = createSelector(
  [offerTokenToPurchaseActionSelector, simpleSelectors.purchase],
  (offerTokenToOffer: OfferTokenToPurchaseAction, purchase: PurchaseDetails) =>
    purchase && {
      ...purchase,
      details: offerTokenToOffer[purchase.offerToken],
    }
)
